import React from 'react';
import { MenuItem } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconMenu from 'components/IconMenu';
import { Highlighted } from 'ui/Highlighted/Highlighted';
import { useTranslation } from 'react-i18next';
import { dynamicYearFilterValue } from '../helpers/definitions';
import { handleOperationSubMenuChange } from '../helpers/operation';

type Props = {
    menuOperation: FilterOperationsT;
    setFilter: (fields: Partial<SentenceFilterT>) => void;
    onClose: () => void;
};

const NestedFilterOperationSelector = ({
    menuOperation,
    setFilter,
    onClose,
}: Props) => {
    const { t } = useTranslation('sentence');
    const thisYearValue = new Date().getFullYear();
    const defaultValue = dynamicYearFilterValue.current;

    const onClickHandler = () => {
        setFilter({
            operation: menuOperation,
            value: defaultValue,
        });
        onClose();
    };

    return (
        <MenuItem
            value={`${menuOperation}-${defaultValue}`}
            onClick={onClickHandler}
            key={menuOperation}
        >
            {`${t(`yearOperations.${menuOperation}`)} ${t(
                `yearOperations.${defaultValue}`,
            )}`}
            <IconMenu
                small
                className="time-filter-menu"
                iconElement={<ChevronRightIcon />}
            >
                {Object.keys(dynamicYearFilterValue).map((value) => (
                    <MenuItem
                        key={`${menuOperation}-${dynamicYearFilterValue[value]}`}
                        value={`${menuOperation}-${dynamicYearFilterValue[value]}`}
                        onClick={handleOperationSubMenuChange(
                            `${menuOperation}-${dynamicYearFilterValue[value]}`,
                            setFilter,
                        )}
                    >
                        {t(`yearOperations.${value}`)}
                    </MenuItem>
                ))}
                <MenuItem
                    value={`${menuOperation}-${thisYearValue}`}
                    onClick={handleOperationSubMenuChange(
                        `${menuOperation}-${thisYearValue}`,
                        setFilter,
                    )}
                >
                    <Highlighted>{thisYearValue}</Highlighted>
                </MenuItem>
            </IconMenu>
        </MenuItem>
    );
};

export default React.memo(NestedFilterOperationSelector);
